const COOKIE_PREFIX = "hideTradesPerfKpis";
const COOKIE_MAX_AGE_SECONDS = 31536000; // 1 year

export const MASKED_PERFORMANCE_VALUE = "****";

const getCookieName = (userId: string) => `${COOKIE_PREFIX}_${userId}`;

export const getHideTradesPerfKpis = (userId: string): boolean => {
    const cookieName = getCookieName(userId);
    const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${cookieName}=`));
    return match?.split("=")[1] === "true";
};

export const setHideTradesPerfKpis = (userId: string, value: boolean): void => {
    document.cookie = `${getCookieName(userId)}=${value}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}`;
};
